<ng-container *transloco="let t">
  <div class="modal-header">
    <h2>{{ t('childHistory/deleteQuestion') }}</h2>
  </div>

  <div class="modal-body">
    <p class="message">{{ t('childHistory/deleteMessage', { field: fieldLabel, value: value, date: validFrom }) }}</p>
    <p class="message">{{ t('childHistory/deleteIrreversible') }}</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-lg btn-outline-primary" (click)="activeModal.dismiss()">
      {{ t('childHistory/cancel') }}
    </button>
    <button type="button" class="btn btn-lg btn-primary" (click)="confirm()">{{ t('childHistory/removeAction') }}</button>
  </div>
</ng-container>
